import i18n from 'i18next';

import { registerCondition } from 'core/forms';

import getEnrollmentsMaximum from '../helpers/getEnrollmentsMaximum';

const isCourseEnrollmentsLimitReached = ({ condition }) => {
  const { enrolledUsers, enrollmentsSelectedUsers } = condition;
  const { difference, maximum } = getEnrollmentsMaximum({
    enrolledUsers,
    enrollmentsSelectedUsers,
  });

  if (maximum && difference > 0) {
    return {
      hasCondition: false,
      condition: null,
      shouldHideField: false,
    };
  }

  return {
    hasCondition: true,
    condition: { error: i18n.t('max-enrollments-reached') },
    shouldHideField: true,
  };
};

registerCondition('isCourseEnrollmentsLimitReached', isCourseEnrollmentsLimitReached);
